const CODE_VERSION = 1.2;
console.log(`🧩 quantity-discount.js v${CODE_VERSION} geladen`);

document.addEventListener("DOMContentLoaded", function () {



  // Nur starten, wenn Bundles vorhanden sind
  const options = document.querySelectorAll(".bundle-option");
  if (options.length === 0) {
    console.log(
      "🛑 Keine Bundle-Optionen gefunden – Script wird nicht ausgeführt"
    );
    return;
  }

    const getQtyInputs = () => [...document.querySelectorAll('input[name="quantity"]')];
    const readQty = () => {
    const inputs = getQtyInputs();
    const visible = inputs.find(el => el.offsetParent !== null) || inputs[0];
    return parseInt(visible?.value || '1', 10);
    };
    function setQtyAll(q){
        getQtyInputs().forEach(el=>{
        el.value = q;
        el.setAttribute('value', q);
        el.dispatchEvent(new Event('input',  {bubbles:true}));
        el.dispatchEvent(new Event('change', {bubbles:true}));
        });
    }

  const priceInfoData = document.getElementById("product-price-info-data");
  const priceElement = document.querySelector(
    ".product-price--original.text-size--heading"
  );
  const compareWrapper = document.querySelector("#compare-price-wrapper");
  const comparePriceEl = document.querySelector("#compare-price");
  const savingsTextEl = document.querySelector("#savings-text");
  const stickyPriceEl = document.querySelector("[data-dynamic-sticky-price]");

  const pricePerDayEl = document.getElementById("price-info_price-per-day");
  const rangeDaysEl = document.getElementById("price-info_product-range-days");
  const pricePerKgEl = document.getElementById("price-info_price-per-kg");

  console.log("✅ Preisdetails gefunden:", priceInfoData);

  
const priceSelector = '.product-price--original.text-size--heading, .product-price';

function getBasePrice() {
  const el = document.querySelector(priceSelector);
  if (!el) return NaN;
  const raw = el.dataset?.basePrice ??
    el.textContent.replace(/[^\d,\.]/g, '').replace(',', '.');
  return parseFloat(raw);
}

const basePrice = getBasePrice();

console.log('DEBUG basePrice check', { basePrice });
if (Number.isNaN(basePrice)) {
  console.warn('⚠️ Preis- oder Basispreis beim ersten Durchlauf nicht gefunden');
}

  function formatMoney(amount) {
    return `€${amount.toFixed(2).replace(".", ",")}`;
  }

  function updateDynamicPrice() {
  const quantity  = readQty();
  let stickyBtnPriceEl = document.querySelector('[data-button-price]');
  let stickyBtnPriceWrap = document.querySelector('[data-button-price-container]');

  // 👇 Jedes Mal frisch ermitteln, nicht die alte Referenz nutzen
  const priceSelector = '.product-price--original.text-size--heading, .product-price';
  const priceEl = document.querySelector(priceSelector);
  const basePrice = getBasePrice();
  if (!priceEl || Number.isNaN(basePrice)) {
    console.warn('⚠️ Preis-Element oder Base-Price fehlen gerade');
    return;
  }

  // Bundle finden
  let matchedOption = null;
  const bundleList = [...options]
    .map(o => ({
      qty: parseInt(o.dataset.qty,10),
      discount: parseFloat(o.dataset.discount || '0'),
      el: o,
    }))
    .filter(o => quantity >= o.qty);
  if (bundleList.length) matchedOption = bundleList.reduce((a,b)=> a.qty>b.qty?a:b);

  // Preise berechnen
  const discount = matchedOption?.discount || 0;
  const finalUnitPrice = basePrice * (1 - discount/100);
  const totalFinal   = finalUnitPrice * quantity;
  const totalCompare = basePrice * quantity;
  const savings      = totalCompare - totalFinal;

  // Preise schreiben (👈 priceEl statt priceElement)
  priceEl.dataset.finalPrice = finalUnitPrice.toFixed(2);
  priceEl.textContent = formatMoney(totalFinal);
  if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(totalFinal);

  // Vergleichspreis sicher updaten (mit Null-Guards)
  if (quantity > 1 && totalCompare > totalFinal && compareWrapper) {
    compareWrapper.style.display = "flex";
    if (comparePriceEl) comparePriceEl.textContent = formatMoney(totalCompare);
    if (savingsTextEl) {
      const template = savingsTextEl.dataset.template || "Du sparst __AMOUNT__";
      savingsTextEl.innerHTML = template.replace("__AMOUNT__", `<span class="price-info-highlight">${formatMoney(savings)}</span>`);
    }
  } else if (compareWrapper) {
    compareWrapper.style.display = "none";
    if (comparePriceEl) comparePriceEl.textContent = "";
    if (savingsTextEl)  savingsTextEl.textContent = "";
  }

  /*
  // Zusatzinfos nur, wenn alle Elemente da sind
  const rangePerUnit = parseInt(priceInfoData?.dataset?.rangePerUnit || '0', 10);
  const netWeight    = parseFloat(priceInfoData?.dataset?.netWeight || '0');
  if (pricePerDayEl && rangeDaysEl && pricePerKgEl && rangePerUnit && netWeight) {
    const totalRange = quantity * rangePerUnit;
    const totalWeight = quantity * netWeight;
    pricePerDayEl.textContent = formatMoney(totalFinal / totalRange);
    rangeDaysEl.textContent = quantity > 1 ? `${quantity} x ${rangePerUnit} Tage` : `${rangePerUnit} Tage`;
    pricePerKgEl.textContent = formatMoney((totalFinal / totalWeight) * 1000);
  }
    */

  // --- START NEUER CODE FÜR BASISPREIS ---
  const unitPriceEl = document.getElementById("price-info_price-per-kg"); // Das Span mit dem Geldbetrag
  const infoDataEl  = document.getElementById("product-price-info-data");

  // Wir brauchen den originalen Grundpreis (als Zahl) aus dem Liquid
  if (unitPriceEl && infoDataEl) {
    const originalUnitPrice = parseFloat(infoDataEl.dataset.originalUnitPrice || '0');
    
    // Berechnen, wie viel Prozent vom Originalpreis noch übrig sind (Faktor)
    // Wenn BasePrice 10€ und FinalPrice 8€ -> Faktor 0.8
    let discountFactor = 1;
    if (basePrice > 0) {
      discountFactor = finalUnitPrice / basePrice;
    }

    // Grundpreis neu berechnen
    if (originalUnitPrice > 0) {
      const newUnitPrice = originalUnitPrice * discountFactor;
      unitPriceEl.textContent = formatMoney(newUnitPrice);
    }
  }
  // --- ENDE NEUER CODE ---

  // Sticky-ATC Preis (re-query, falls Bar später gemountet wird)
    stickyBtnPriceEl   = stickyBtnPriceEl   || document.querySelector('[data-button-price]');
    stickyBtnPriceWrap = stickyBtnPriceWrap || document.querySelector('[data-button-price-container]');
      if (stickyBtnPriceEl) {
        stickyBtnPriceEl.textContent = totalFinal.toFixed(2).replace('.', ','); // z.B. 85,80
      }
      if (stickyBtnPriceWrap) {
        // Falls der Wrap selbst Text enthält (z. B. "€"), lassen wir ihn wie er ist
        // (nur der <span data-button-price> wird überschrieben)
      }

  // Aktive Option markieren
  options.forEach(o => o.classList.toggle("is-active", matchedOption && parseInt(o.dataset.qty,10) === matchedOption.qty));
}

  // Klick auf Bundle → alle Qty-Felder synchronisieren
options.forEach((option) => {
  option.addEventListener("click", () => {
    const qty = parseInt(option.dataset.qty || "1", 10);
    setQtyAll(qty);
    setTimeout(() => setQtyAll(qty), 60); // gegen asynchrone Theme-Resets
    updateDynamicPrice();
  });
});

  // Plus/Minus-Buttons triggern
  document
  .querySelectorAll(".product-quantity__plus, .product-quantity__minus")
  .forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(updateDynamicPrice, 120);
    });
  });

    ['change','input','keyup'].forEach(evt=>{
    getQtyInputs().forEach(el=> el.addEventListener(evt, updateDynamicPrice));
    });

  updateDynamicPrice(); // Init
  console.log("Neuer Code aktiv");
});